// src-lit/components/product/title.logic.ts
/**
 * 商品タイトル解決ロジック（純粋関数）
 *
 * 表示するタイトル文字列は SSR 時に Liquid 側（getProductVariantTitle.liquid）で
 * 全バリアント分を生成し、TitleMap として埋め込まれる。
 * Lit 側は variantId から該当タイトルを引くだけにすることで、
 * 命名規則ロジックを Liquid と TS で重複させない。
 */

export type TitleMap = Record<string, string>;

export function getTitleForVariant(map: TitleMap, variantId: string): string | undefined {
  return map[variantId];
}
